import {
  SidePanel,
  ButtonPrimary,
  ButtonSecondary,
  IconLoader,
  PermissionEnum,
} from '@ui/src';
import GroupFrom from '../../../components/charts/charts-panel/charts-panel-group';
import useGroupEdit from './hooks/use-edit';

import cn from '../styles.module.css';

const GroupFormHOC = (): React.JSX.Element => {
  const {
    typeOptions,
    selectedGroupIsLoading,
    activePermissions,
    group,
    control,
    errors,
    requestInProgress,
    onSubmit,
    panelIsOpen,
    handleClose,
    categories,
    selectedGroup,
    categoryId,
    groupId,
  } = useGroupEdit();

  let content;

  if (selectedGroupIsLoading) {
    content = (
      <div className={cn.selectedCategoryLoading}>
        <IconLoader />
      </div>
    );
  } else {
    content = (
      <GroupFrom
        control={control}
        category={categories.find((category) => category.id === categoryId)}
        name={selectedGroup?.description}
        group={group}
        typeOptions={typeOptions}
        errors={errors}
        groupId={groupId}
        groupNumber={group.number}
      />
    );
  }

  return (
    <SidePanel
      closeOnClickOutside={false}
      isOpen={panelIsOpen}
      onClose={handleClose}
      parent={document.getElementById('chart-modal') as HTMLElement}
      title={`Group ${
        activePermissions?.includes(
          PermissionEnum.ACCOUNTS_CHART_EDIT_GROUP_ACTION,
        )
          ? 'Edit'
          : 'Info'
      }`}
      className={cn.chartSidePanel}
      sidepanelExpandedKey="charts-group-edit"
      footer={
        <>
          {activePermissions?.includes(
            PermissionEnum.ACCOUNTS_CHART_EDIT_GROUP_ACTION,
          ) && (
            <ButtonPrimary
              text={requestInProgress ? 'Loading...' : 'Save'}
              disabled={requestInProgress}
              onClick={onSubmit}
            />
          )}
          <ButtonSecondary text="Close" onClick={handleClose} />
        </>
      }
    >
      {content}
    </SidePanel>
  );
};

export default GroupFormHOC;
